/**
 * Panel-scale eyebrow.
 *
 * The `.eyebrow` utility is 13px at 0.2em tracking, which is right for a
 * section heading on a card and far too loud stacked eight times inside a
 * popover. Same voice (display face, uppercase, tracked), quieter.
 *
 * Shared rather than redeclared per feature: it was a local constant in
 * Inventory, and the second page that wanted the same voice would otherwise
 * have guessed at the numbers.
 */
export const MICRO_LABEL =
  "font-display text-[10px] font-semibold uppercase tracking-[0.14em] text-muted-foreground";

/**
 * The design system's `overline`: 11px, 600, 0.08em, uppercase, in the
 * eyebrow colour.
 *
 * For a label that names a group of things once (a lane, a column of cards)
 * where the 13px section `.eyebrow` would shout louder than the things it
 * labels. Not for section headings, which keep `.eyebrow`.
 */
export const OVERLINE =
  "font-display text-[11px] font-semibold uppercase leading-4 tracking-[0.08em] text-eyebrow";
